import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Button, Form, FormGroup, Label, Input, Col, Row } from "reactstrap";
import toast from "react-hot-toast";
import useApi from "common/ApiMiddlewere";
import Flatpickr from "react-flatpickr";
import { dateFormat, formatDateToISO } from "pages/Common";

const EmployeeLeaveModal = ({ modal, toggle, employeeId, isEdit, editData, EmpLeaveListApi }) => {
    const { postApi, getApi } = useApi();
    const [leaveHours, setLeaveHours] = useState(editData?.LeaveHours || 0);
    const [users, setUsers] = useState([]);
    const [userId, setUserId] = useState(editData?.AttendanceUserId || 0);
    const [loading, setLoading] = useState(false);
    const [leaveType, setLeaveType] = useState(editData?.IsFullDay || false);
    const [fromDate, setFromDate] = useState(editData ? dateFormat(
        editData?.FromDate?.split("T")[0],
        "dd-MM-yyyy"
    ) : dateFormat(
        new Date(),
        "dd-MM-yyyy"
    ))
    const [toDate, setToDate] = useState(editData ? dateFormat(
        editData?.ToDate?.split("T")[0],
        "dd-MM-yyyy"
    ) : dateFormat(
        new Date(),
        "dd-MM-yyyy"
    ))
    const [remark, setRemark] = useState(editData?.Remarks || '');

    useEffect(() => {
        getApi('Attendance/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data);
                const filtered = data.filter(user => parseInt(user.Value2) == (JSON.parse(localStorage.getItem("authUser")).Id));
                setUserId(isEdit ? editData?.AttendanceUserId : filtered[0]?.Key || 0);
            } else {
                toast.error(data, { style: { fontSize: "15px" } });
            }
        });
    }, []);

    const handleSubmit = () => {
        if (userId > 0 || employeeId > 0) {
            setLoading(true)
            postApi("Attendance/emp-leave-add-edit", {
                Id: editData ? editData.Id : 0,
                AttendanceUserId: parseInt(userId) == 0 ? employeeId : parseInt(userId),
                isFullDay: leaveType,
                leaveHours: leaveHours,
                FromDate: formatDateToISO(fromDate),
                toDate: formatDateToISO(toDate),
                remarks: remark
            }).then(({ data, status }) => {
                setLoading(false)
                if (status === 200) {
                    toggle()
                    toast.success(isEdit ? "Successfully Updated" : "Successfully Added", { style: { fontSize: "15px" } });
                } else {
                    toast.error(data, { style: { fontSize: "15px" } });
                }
                setLoading(false);
                setUserId(0)
                toggle()
                if (EmpLeaveListApi != '') {
                    EmpLeaveListApi()
                }
            });
        } else {
            toast.error("Please select employee", { style: { fontSize: "15px" } });
        }
    };

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const handleFromDate = (date) => {
        setFromDate(date)
        setToDate(date)
    }

    return (
        <>
            <Modal isOpen={modal} toggle={toggle} centered={true} size="defualt" style={{ width: "350px" }}>
                <div className="modal-content">
                    <ModalHeader className="text-centre" toggle={toggle} tag="h5">
                        <span> {isEdit ? "Update Leave" : "Add Leave"} </span>
                    </ModalHeader>
                    <ModalBody>
                        <React.Fragment>
                            <Form>
                                {employeeId == 0 &&
                                    <Row className="mb-3">
                                        <Col md={12}>
                                            <Label for="userId" className="form-label">Employee</Label>
                                            <Input
                                                type="select"
                                                id="validationCustom01"
                                                className="form-control-sm"
                                                name="user"
                                                bsSize="sm"
                                                onChange={e => {
                                                    setUserId(e.target.value)
                                                }}
                                                value={userId}
                                            >
                                                <option value={0}>Select Employee</option>
                                                {users.map((item, index) => {
                                                    return (
                                                        <option key={index} value={item.Key}>
                                                            {item.Value}
                                                        </option>
                                                    )
                                                })}
                                            </Input>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    <Col md={4} style={{ marginTop: "26px" }}>
                                        <FormGroup check>
                                            <Input
                                                type="checkbox"
                                                id='leavetype'
                                                defaultChecked={leaveType}
                                                onChange={(e) => setLeaveType(e.target.checked)}
                                            />
                                            <Label for='leavetype' check>
                                                Is Full Day
                                            </Label>
                                        </FormGroup>
                                    </Col>
                                    <Col md={8}>
                                        <FormGroup>
                                            <Label for="salary" className="form-label">Leave Hours</Label>
                                            <Input
                                                type="text"
                                                disabled={leaveType}
                                                id="salary"
                                                className="form-control form-control-sm"
                                                name="leaveHours"
                                                bsSize="sm"
                                                onKeyPress={handleKeyPress}
                                                value={leaveHours}
                                                onChange={e => setLeaveHours(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}> <div className="mb-2">
                                        <Label
                                            htmlFor="productDetailsValidationCustom01"
                                            className="required"
                                        >
                                            From Date
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                value={fromDate}
                                                onChange={(e) => handleFromDate(e)}
                                                options={{
                                                    dateFormat: "d-m-Y",
                                                    disableMobile: true
                                                }}
                                            />
                                        </div>
                                    </div>
                                    </Col>
                                    <Col md={6}> <div className="mb-2">
                                        <Label
                                            htmlFor="productDetailsValidationCustom01"
                                            className="required"
                                        >
                                            To Date
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                value={toDate}
                                                onChange={(e) => setToDate(e)}
                                                // options={{
                                                //     dateFormat: "d-m-Y",
                                                //     disableMobile: true
                                                // }}
                                                options={{
                                                    dateFormat: "d-m-Y",
                                                    minDate: fromDate,
                                                    disableMobile: true
                                                }}
                                            />
                                        </div>
                                    </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} className="mt-2">
                                        <FormGroup>
                                            <Label for="remark" className="form-label">Remarks</Label>
                                            <Input
                                                type="textarea"
                                                placeholder="Enter remark here"
                                                rows='3'
                                                id="Remarks"
                                                className="form-control form-control-sm"
                                                name="Remarks"
                                                value={remark}
                                                onChange={e => setRemark(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <div className="text-end">
                                    {loading ? (
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            color="secondary"
                                        >
                                            <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                            Loading
                                        </button>
                                    ) : (
                                        <Button
                                            user="primary"
                                            className="btn btn-primary btn-sm "
                                            type="button"
                                            color="primary"
                                            onClick={() => handleSubmit()}
                                        >
                                            Submit
                                        </Button>
                                    )}
                                </div>
                            </Form>
                        </React.Fragment >
                    </ModalBody>
                </div>
            </Modal >
        </>
    );
}

export default EmployeeLeaveModal;
